module.exports = __webpack_public_path__ + "static/media/google_23.3c559c27.svg";